import {defineStore} from "pinia";
import {makeStore} from "../../../utils/search";

export const useSearchStore = defineStore('search', makeStore);
